import React, { useState, useCallback, useEffect } from "react";
import { I18n } from "@td/shared_utils";
import { AutoDialerV2 as api } from "@td/auto_dialer";
import { useAutoDialer } from "../../utils";
import Link from "../Link";
import styles from "./styles.module.scss";

const MemberPhones = () => {
  const {
    consultation: {
      consultationId,
      phoneNumber: primaryPhone,
      alternatePhoneNumber: secondaryPhone,
    },
  } = useAutoDialer();

  const [isOpen, setIsOpen] = useState(false);
  const [wasShown, setWasShown] = useState(false);

  const handleToggle = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && !wasShown) {
      setWasShown(true);
      api.updateMemberNumberShown(consultationId);
    }
  }, [isOpen, wasShown])

  return (
    <div>
      <div
        className={styles.memberPhonesLink}
        data-testid="auto-dialer-member-phones-toggle-button"
      >
        <Link onClick={handleToggle}>
          {isOpen ? (
            <I18n scope="autodialer.call_interface.fallbacks" text="hide_member_number" />
          ) : (
            <I18n scope="autodialer.call_interface.fallbacks" text="show_member_number" />
          )}
        </Link>
      </div>

      {isOpen && (
        <div
          className={styles.memberPhones}
          data-testid="auto-dialer-member-phones-container"
        >
          {primaryPhone && (
            <p data-testid="auto-dialer-member-primary-phone">
              <b>
                <I18n scope="autodialer.call_interface.fallbacks" text="primary_phone" />
              </b>
              : {primaryPhone}
            </p>
          )}
          {secondaryPhone && (
            <p data-testid="auto-dialer-member-secondary-phone">
              <b>
                <I18n scope="autodialer.call_interface.fallbacks" text="secondary_phone" />
              </b>
              : {secondaryPhone}
            </p>
          )}
          {!primaryPhone && !secondaryPhone && (
            <p>
              <I18n scope="misc" text="none" />
            </p>
          )}
          <p>
            <I18n scope="autodialer.call_interface.fallbacks" text="star_67_reminder" />
          </p>
        </div>
      )}
    </div>
  );
};

export default MemberPhones;
